import React from 'react';
import { useTranslation } from 'react-i18next';

import { RowError } from 'interfaces/api_import.interfaces';


interface RowErrorProps {
  rowNumber: number;
  errors: Omit<RowError, 'rowNumber'>[];
}

export const RowErrorComponent: React.FC<RowErrorProps> = ( { rowNumber, errors } ) => {

  const { t } = useTranslation();

  /*---------------------------- Front ------------------------------*/
  return (
    <>
      {
        errors.length > 0 && (
          <div className='flex flex-col'>
            <span className=''>
              { t( 'at_row' ).replace( '{{rowNumber}}', String( rowNumber ) ) }
            </span>
            <ul className='list-disc px-8'>
              {
                errors?.map( ( error, idx ) => {
                  return (
                    <li key={ idx }>
                      <span> { error.field } : { error.msg } </span>
                    </li>
                  );
                } )
              }
            </ul>
          </div>

        )
      }
    </>
  );

};